// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social[data-v-644b7d8b]{position:-webkit-sticky;position:sticky;top:30vh;float:left;opacity:0;transition:opacity 1s}.social.visible[data-v-644b7d8b]{opacity:1}.social ul li[data-v-644b7d8b]{opacity:.6;transition:opacity .3s;margin-bottom:1rem;border:1px solid;display:flex;border-radius:5px;padding:5px;cursor:pointer}.social ul li[data-v-644b7d8b]:hover{opacity:1}", ""]);
// Exports
module.exports = exports;
